import commandUtils from 'utils/commandUtils';
import elementUtils from 'utils/elementUtils';
import selectionUtils from 'utils/selectionUtils';

var RESET_CMDS = [
    'fontSize',
    'bold',
    'unBold',
    'italic',
    'unItalic',
    'fontFamily',
    'foreColor',
    'underline',
    'textShadow',
    'backColor',
    'letterSpacing',
    'fontWeight'
];
const resetStyleName = [
    'font-size',
    'font-weight',
    'font-style',
    'font-family',
    'color',
    'text-decoration',
    'text-shadow',
    'background-color',
    'letter-spacing'
];

export default {
    exec: function (editor) {
        var thisCommand = editor.getCommand('resetThemeAndStyles');
        if (thisCommand.canUndo) {
            editor.undoManager.save();
        }
        editor.undoManager.lock(true);

        var i, command;
        for (i = 0; i < RESET_CMDS.length; i++) {
            command = editor.getCommand(RESET_CMDS[i]);
            if (command.style) {
                editor.removeStyle(command.style);
            } else {
                commandUtils.execNestedCommand(command, thisCommand, CKEDITOR.TRISTATE_OFF);
            }
        }
        selectionUtils.getSelectedLists(editor).forEach(element => {
            resetStyleName.forEach(styleName => {
                element.removeStyle(styleName);
            });
        });

        editor.undoManager.unlock();
    },
    applyOnElement: function (value, element) {
        element.removeAttributes(['class', 'style']);
        // after the reset we need to  apply the theme class to the LI
        elementUtils.cloneClassesToElement(element.getFirst(), element);
    },
    canUndo: true
};
